import * as constants from './constants';

export const getWishlistItems = () => ({ type: constants.GET_WISHLIST_ITEMS });
export const getWishlistItemsDelayed = (payload) => ({ type: constants.GET_WISHLIST_ITEMS_DELAYED, payload });
export const getWishlistItemsSuccess = (payload) => ({
  type: constants.GET_WISHLIST_ITEMS_SUCCESS,
  payload,
});
export const getWishlistItemsError = (payload) => ({
  type: constants.GET_WISHLIST_ITEMS_ERROR,
  payload,
});

export const selectItem = (payload) => ({ type: constants.SELECT_WISHLIST_ITEM, payload });
export const deselectItem = (payload) => ({ type: constants.DESELECT_WISHLIST_ITEM, payload });
export const deselectMany = (payload) => ({
  type: constants.DESELECT_MANY_WISHLIST_ITEMS,
  payload,
});
export const resetWishlistItems = () => ({ type: constants.RESET_WISHLIST_ITEMS });
export const resetWishlistItemsActions = () => ({ type: constants.RESET_WISHLIST_ITEMS_ACTIONS });
export const openWishlistItem = (payload) => ({ type: constants.OPEN_WISHLIST_ITEM, payload });
export const closeWishlistItem = () => ({ type: constants.CLOSE_WISHLIST_ITEM });

export const setWishlistItemsFilters = (payload) => ({
  type: constants.SET_WISHLIST_ITEMS_FILTERS,
  payload,
});

export const setWishlistItemsQuery = (payload) => ({
  type: constants.SET_WISHLIST_ITEMS_QUERY,
  payload,
});

export const updateWishlistItems = (payload) => ({
  type: constants.UPDATE_WISHLIST_ITEMS,
  payload,
});
